import Loadable from '../../../components/loadable';

const MergeContact = Loadable({
  loader: () => import('react/pages/contacts/merge_contact/merge_contact'),
});

angular.module('gym').value('MergeContact', MergeContact);
